import axios from '@/libs/api.request'
// 小程序全局配置
export const getMinisSetting = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/page'
  })
}
// 新增小程序
export const addMinisSetting = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/add'
  })
}
